import moment from "moment";
import { getLangFromCookies } from "./langHelpers";

export const CustomShortDateFormatter = (date, format = "MMM DD, YYYY") => {
    if (!date) return "";

    const currentLangIsFrench = getLangFromCookies() === "fr";

    if (currentLangIsFrench) {
        moment.locale("fr", { monthsShort: "janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc".split("_") });
    }

    return moment(date).format(format);
};
